import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useAuthDataContext } from "../AuthDataProvider";

function HarnessId(props) {
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthDataContext();
  useEffect(() => {
    if (props.type === "Sentree") {
      setIsLoading(true);
      FleetWebApi.getLastHarnessRecord(props.coreId, user.token)
        .then((response) => {
          setResponse(response);
          console.log("HarnessID.jsx", response);
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        });
    }
  }, [props.coreId, props.type, user.token]);
  return (
    <Fragment>
      {props.type === "Sentree" ? (
        <TableRow>
          <TableCell component="th" scope="row">
            Last Harness Record
          </TableCell>
          <TableCell data-th="All Proxies (Last 30 Days)">
            {isLoading && <CircularProgress color="secondary" />}
            {error && error !== "NOT FOUND" && (
              <p>Error Loading Data: {error}</p>
            )}
            {response && (
              <Fragment>
                T1:{" "}
                <a
                  href={
                    "https://mfgweb.alertlabs.com/device/" + response.payload.t1
                  }
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {response.payload.t1}
                </a>
                <IconButton>
                  <a
                    href={
                      "https://mfgweb.alertlabs.com/device/" +
                      response.payload.t1
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    className="mfgweb"
                  >
                    <OpenInNewIcon />
                  </a>
                </IconButton>
                <br />
                T2:{" "}
                <a
                  href={
                    "https://mfgweb.alertlabs.com/device/" + response.payload.t2
                  }
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {response.payload.t2}
                </a>
                <IconButton>
                  <a
                    href={
                      "https://mfgweb.alertlabs.com/device/" +
                      response.payload.t2
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    className="mfgweb"
                  >
                    <OpenInNewIcon />
                  </a>
                </IconButton>
                <br />
                T3:{" "}
                <a
                  href={
                    "https://mfgweb.alertlabs.com/device/" + response.payload.t3
                  }
                  rel="noopener noreferrer"
                  target="_blank"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  {response.payload.t3}
                </a>
                <IconButton>
                  <a
                    href={
                      "https://mfgweb.alertlabs.com/device/" +
                      response.payload.t3
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    className="mfgweb"
                  >
                    <OpenInNewIcon />
                  </a>
                </IconButton>
                <br />
              </Fragment>
            )}
          </TableCell>
        </TableRow>
      ) : null}
    </Fragment>
  );
}

export default HarnessId;
